/* Prismoon cart gate. Intercepts the cart-page and drawer checkout buttons in
   the capture phase and shows a size-confirmation modal: a dynamic graphic and
   the duct opening per item, plus an optional size change (swap to a same-model
   size, or remove and see similar products in the wanted size).
   Fails open: any error lets the normal checkout proceed. */
(function () {
  var cfg = window.AGCartGate || {};
  if (!cfg.enabled) return;

  var SELECTOR = '#cart-checkout, #cart-sidebar-checkout, .button-checkout';
  var SESSION_KEY = 'agCartGateOK';
  var UNCONF_KEY = 'agUnconfirmedVids';

  function confirmed() { try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; } }
  function setConfirmed() { try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {} }
  // persistent opt-out ("don't show again, I know my sizes")
  function dismissed() { try { return localStorage.getItem('agCartGateDismissed') === '1'; } catch (e) { return false; } }
  function unconfSet() { try { return new Set(JSON.parse(sessionStorage.getItem(UNCONF_KEY) || '[]')); } catch (e) { return new Set(); } }

  function overlay() { return document.querySelector('[data-ag-cart-gate]'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(n) { return (n % 1 === 0) ? String(n) : String(n); }
  // prismoon 2026-10-03: read W x H out of the size metafield text (2"W x 10"H, 12" x 6", 3-3/8"W X 11-3/8"H)
  function num(t) {
    t = String(t).trim();
    var m = t.match(/^(\d+)(?:[-\s]+(\d+)\/(\d+))?$/); if (m) return +m[1] + (m[2] ? m[2] / m[3] : 0);
    m = t.match(/^(\d+)\/(\d+)$/); if (m) return m[1] / m[2];
    var f = parseFloat(t); return isNaN(f) ? null : f;
  }
  // prismoon 2026-10-03: swap the two sides of a W x H text, keeping its own spelling (2"W x 10"H -> 10"W x 2"H)
  function flipWH(s) {
    var m = String(s || '').match(/^\s*(\d[\d\-\/. ]*?)\s*"?\s*W?\s*([x\u00d7])\s*(\d[\d\-\/. ]*?)\s*"?\s*H?\s*$/i);
    return m ? (m[3] + '"W ' + m[2] + ' ' + m[1] + '"H') : s;
  }
  // toe kick registers (520101) are installed lying down: the modal shows them landscape, wide side as W
  var LANDSCAPE_ITEMS = /^520101-/;
  function parseWH(s) {
    var m = String(s || '').replace(/[\u201d\u2033]/g, '"').match(/(\d[\d\-\/. ]*)\s*"?\s*W?\s*[x\u00d7]\s*(\d[\d\-\/. ]*)\s*"?\s*H?/i);
    if (!m) return null;
    var w = num(m[1]), h = num(m[2]);
    return (w != null && h != null) ? { w: w, h: h } : null;
  }

  function checkoutTarget(btn) {
    if (btn && btn.dataset && btn.dataset.href) return btn.dataset.href;
    var oc = btn && btn.getAttribute ? (btn.getAttribute('onclick') || '') : '';
    var m = oc.match(/window\.location\s*=\s*'([^']+)'/);
    if (m) return m[1];
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
  }

  function serverMap() {
    try {
      var node = document.querySelector('script[data-ag-gate-cart]');
      var data = node ? JSON.parse(node.textContent) : { items: [] };
      var m = {}; (data.items || []).forEach(function (it) { m[String(it.id)] = it; }); return m;
    } catch (e) { return {}; }
  }

  function loadModelMap() {
    if (window.AIRGRILLES_MODEL_MAP) return Promise.resolve(window.AIRGRILLES_MODEL_MAP);
    if (window.__agModelMapP) return window.__agModelMapP;
    window.__agModelMapP = new Promise(function (res) {
      if (!cfg.mapUrl) { res({ groups: {}, variants: {}, widths: [], heights: [] }); return; }
      var s = document.createElement('script');
      s.src = cfg.mapUrl;
      s.onload = function () { res(window.AIRGRILLES_MODEL_MAP || { groups: {}, variants: {}, widths: [], heights: [] }); };
      s.onerror = function () { res({ groups: {}, variants: {}, widths: [], heights: [] }); };
      document.head.appendChild(s);
    });
    return window.__agModelMapP;
  }

  function postJSON(url, data) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function groupFor(map, vid) {
    var gkey = map.variants ? map.variants[String(vid)] : null;
    var grp = (gkey && map.groups) ? map.groups[gkey] : null;
    var items = grp ? (grp.items || []) : [];
    var current = null;
    items.forEach(function (x) { if (String(x.vid) === String(vid)) current = x; });
    return { current: current, items: items };
  }

  // dynamic graphic: faceplate (outer) with the duct opening drawn to the W:H ratio
  function sizeSvg(w, h) {
    var ac = cfg.accent || '#2e9bd6';
    if (w == null || h == null || isNaN(w) || isNaN(h)) return '';
    var box = 72, s = box / Math.max(w, h);
    var iw = Math.max(44, Math.round(w * s)), ih = Math.max(44, Math.round(h * s));
    var pad = 12, ox = 12, oy = 12;
    var ow = iw + pad * 2, oh = ih + pad * 2;
    var W = ox + ow + 8, H = oy + oh + 8;
    var ix = ox + pad, iy = oy + pad;
    var fs = 'font-family:Arial,Helvetica,sans-serif;font-style:normal';
    return '<svg class="agcg-svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" style="width:' + W + 'px;height:' + H + 'px;flex:none;display:block" aria-hidden="true">' +
      '<rect x="' + ox + '" y="' + oy + '" width="' + ow + '" height="' + oh + '" rx="3" fill="#f1f5f8" stroke="#9fb0bd" stroke-dasharray="3 2"/>' +
      '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '" rx="2" fill="' + ac + '" fill-opacity="0.16" stroke="' + ac + '" stroke-width="2.4"/>' +
      '<text x="' + (ix + iw / 2) + '" y="' + (iy + 15) + '" text-anchor="middle" font-size="13" font-weight="700" fill="' + ac + '" style="' + fs + '">' + fmt(w) + '"</text>' +
      '<text x="' + (ix + 14) + '" y="' + (iy + ih / 2 + 4) + '" text-anchor="middle" font-size="13" font-weight="700" fill="' + ac + '" style="' + fs + '" transform="rotate(-90 ' + (ix + 14) + ' ' + (iy + ih / 2) + ')">' + fmt(h) + '"</text>' +
      '</svg>';
  }

  // neck / round: a circle (round duct) with the diameter inside
  function circleSvg(d) {
    var ac = cfg.accent || '#2e9bd6';
    if (d == null || isNaN(d)) return '';
    var R = 34, cx = R + 16, cy = R + 14, W = cx + R + 16, H = cy + R + 14;
    var fs = 'font-family:Arial,Helvetica,sans-serif;font-style:normal';
    return '<svg class="agcg-svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" style="width:' + W + 'px;height:' + H + 'px;flex:none;display:block" aria-hidden="true">' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + (R + 8) + '" fill="#f1f5f8" stroke="#9fb0bd" stroke-dasharray="3 2"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + R + '" fill="' + ac + '" fill-opacity="0.16" stroke="' + ac + '" stroke-width="2.4"/>' +
      '<text x="' + cx + '" y="' + (cy + 5) + '" text-anchor="middle" font-size="14" font-weight="700" fill="' + ac + '" style="' + fs + '">' + fmt(d) + '"</text>' +
      '</svg>';
  }

  function graphicFor(cur) {
    if (!cur) return '';
    if (cur.kind === 'wxh') return sizeSvg(cur.w, cur.h);
    if (cur.kind === 'neck' || cur.kind === 'round') return circleSvg(cur.d);
    return '';
  }

  function pickOptions(arr, cur) {
    return (arr || []).map(function (n) { return '<option value="' + n + '"' + (n === cur ? ' selected' : '') + '>' + fmt(n) + '"</option>'; }).join('');
  }

  function changePanel(map, cur) {
    var lbl = 'Pick the size you need (the duct opening):', inner;
    if (cur.kind === 'wxh') {
      inner = '<select data-ag-w>' + pickOptions(map.widths, cur.w) + '</select>' +
              '<span class="agcg-pick__x">x</span>' +
              '<select data-ag-h>' + pickOptions(map.heights, cur.h) + '</select>';
    } else {
      lbl = cur.kind === 'neck' ? 'Pick the neck size you need:' : 'Pick the diameter you need:';
      inner = '<select data-ag-d>' + pickOptions(cur.kind === 'neck' ? map.necks : map.rounds, cur.d) + '</select>';
    }
    return '<div class="agcg-line__panel" data-ag-change-panel hidden>' +
      '<div class="agcg-pick"><span class="agcg-pick__lbl">' + lbl + '</span>' + inner +
        '<button class="agcg-change__switch" type="button" data-ag-switch disabled>' + esc(cfg.switchLabel || 'Switch') + '</button>' +
      '</div>' +
      '<div class="agcg-change__msg" data-ag-change-msg></div>' +
    '</div>';
  }

  // prismoon 2026-10-03: the size data in the page is rendered once, at page load. Items added later (quick order,
  // PDP, drawer) were missing from it and fell back to the model map (520101-9 showed 10 x 2 against 2"W x 10"H in
  // the table). Re-render this section for the current cart through the Section Rendering API so every line gets
  // its own size and outer metafields. Any failure falls back to the copy in the page.
  function freshServerMap() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return fetch(root + '?sections=airgrilles-cart-gate-prismoon-v3', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['airgrilles-cart-gate-prismoon-v3'];
        var m = html && html.match(/<script type="application\/json" data-ag-gate-cart>([\s\S]*?)<\/script>/);
        if (!m) return serverMap();
        var data = JSON.parse(m[1]), out = {};
        (data.items || []).forEach(function (it) { out[String(it.id)] = it; });
        return out;
      })
      .catch(function () { return serverMap(); });
  }

  function renderLines(map) {
    if (!cfg.showMeasurements) return Promise.resolve();
    var host = document.querySelector('[data-ag-gate-lines]');
    if (!host) return Promise.resolve();
    var smap = {}, unconf = unconfSet();
    return freshServerMap()
      .then(function (m) { smap = m || {}; return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        host.innerHTML = cart.items.map(function (it) {
          var sm = smap[String(it.id)] || {};
          var grp = map ? groupFor(map, it.id) : { current: null, items: [] };
          var cur = grp.current;
          var kind = cur ? cur.kind : '';
          /* prismoon 2026-10-03: duct from the product's size metafield first, like outer below. The model map had
             520101-9 as 10 x 2 while the metafield, the quick order table and the outer size say 2"W x 10"H, so the
             modal showed a rotated duct next to an unrotated faceplate. The map stays the fallback and still drives swaps. */
          var duct = sm.duct || (cur && cur.size) || '';
          var smWH = (kind === 'neck' || kind === 'round') ? null : parseWH(sm.duct);
          /* prismoon 2026-09-30: the product's own outer_dimensions metafield first (rendered live at cart
   time), the model map only as a fallback. The map carried stale derived sizes: 220101-11 printed
   11-5/8 x 7-5/6 while the metafield and the submittal drawing both say 11-3/4 x 7-13/16. */
          var outer = sm.outer || (cur && cur.outer) || '';
          var itemNo = (cur && cur.inum) || sm.sku || it.sku || '';
          /* prismoon 2026-10-03 (owner): toe kicks landscape, as before. Their size metafields are written portrait
             (2"W x 10"H); duct, faceplate and drawing are turned together so the three always agree. */
          if (LANDSCAPE_ITEMS.test(String(itemNo)) && kind !== 'neck' && kind !== 'round') {
            var lwh = parseWH(duct);
            if (lwh && lwh.w < lwh.h) { duct = flipWH(duct); outer = flipWH(outer); smWH = { w: lwh.h, h: lwh.w }; }
          }
          var label = kind === 'neck' ? 'Neck size' : 'Duct opening';
          var warn = unconf.has(String(it.id));
          var hasDims = cur && (kind === 'wxh' ? cur.w != null : cur.d != null);
          var canChange = cfg.enableSwap && hasDims && grp.items.length > 1;
          return '<div class="agcg-lineblock' + (warn ? ' is-unconfirmed' : '') + '" data-ag-line data-vid="' + it.id + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" data-kind="' + esc(kind) + '" data-w="' + ((cur && cur.w != null) ? cur.w : '') + '" data-h="' + ((cur && cur.h != null) ? cur.h : '') + '" data-d="' + ((cur && cur.d != null) ? cur.d : '') + '" data-air="' + esc((cur && cur.air) || '') + '">' +
            '<div class="agcg-line">' +
              (smWH ? sizeSvg(smWH.w, smWH.h) : graphicFor(cur)) +
              '<div class="agcg-line__info">' +
                (itemNo ? '<div class="agcg-line__sku">' + esc(itemNo) + '</div>' : '') +
                '<div class="agcg-line__lbl">' + label + (warn ? ' <span class="agcg-flag">unconfirmed</span>' : '') + '</div>' +
                '<div class="agcg-line__duct">' + esc(duct || '-') + '</div>' +
                (outer ? '<div class="agcg-line__outer">Faceplate (outer): <strong>' + esc(outer) + '</strong></div>' : '') +
                '<div class="agcg-line__qty">Qty ' + it.quantity + '</div>' +
              '</div>' +
            '</div>' +
            (canChange ? changePanel(map, cur) : '') +
          '</div>';
        }).join('');
        if (checkMode) setPanels(true);
      })
      .catch(function () {});
  }

  function showResult(line, match, sizeTxt, dims) {
    var msg = line.querySelector('[data-ag-change-msg]'), sw = line.querySelector('[data-ag-switch]');
    if (match && match.av) {
      sw.disabled = false; sw.setAttribute('data-target', match.vid);
      msg.innerHTML = '<strong>' + esc(sizeTxt) + '</strong> is available in this style. Click <strong>' + esc(cfg.switchLabel || 'Switch') + '</strong>.';
      return;
    }
    // both out-of-stock and not-made offer the same path: remove and see similar
    var why = (match && !match.av) ? 'is currently out of stock in this style' : 'is not made in this style';
    var attrs = dims.kind === 'wxh' ? ('data-w="' + dims.w + '" data-h="' + dims.h + '"') : ('data-d="' + dims.d + '"');
    msg.innerHTML = '<strong>' + esc(sizeTxt) + '</strong> ' + why + '.<br>' +
      '<a href="#" class="agcg-similar-btn" data-ag-similar data-kind="' + dims.kind + '" ' + attrs + '>Remove this and see similar ' + esc(sizeTxt) + ' products &rarr;</a>';
  }

  function evaluate(line) {
    var msg = line.querySelector('[data-ag-change-msg]'), sw = line.querySelector('[data-ag-switch]');
    var kind = line.getAttribute('data-kind') || 'wxh';
    var air = line.getAttribute('data-air') || '';
    var map = window.AIRGRILLES_MODEL_MAP || {};
    var gkey = map.variants ? map.variants[line.getAttribute('data-vid')] : null;
    var items = (gkey && map.groups && map.groups[gkey]) ? map.groups[gkey].items : [];
    sw.disabled = true; sw.removeAttribute('data-target');
    if (kind === 'wxh') {
      var ws = line.querySelector('[data-ag-w]'), hs = line.querySelector('[data-ag-h]');
      if (!ws || !hs) return;
      var w = parseFloat(ws.value), h = parseFloat(hs.value);
      if (isNaN(w) || isNaN(h)) { msg.textContent = ''; return; }
      var sizeTxt = fmt(w) + '" x ' + fmt(h) + '"';
      if (w === parseFloat(line.getAttribute('data-w')) && h === parseFloat(line.getAttribute('data-h'))) { msg.innerHTML = 'That is your current size.'; return; }
      var m1 = null; items.forEach(function (x) { if (x.w === w && x.h === h && (x.air || '') === air) m1 = x; });
      showResult(line, m1, sizeTxt, { kind: 'wxh', w: w, h: h });
    } else {
      var ds = line.querySelector('[data-ag-d]');
      if (!ds) return;
      var d = parseFloat(ds.value);
      if (isNaN(d)) { msg.textContent = ''; return; }
      var sizeTxt2 = fmt(d) + '"' + (kind === 'neck' ? ' neck' : '');
      if (d === parseFloat(line.getAttribute('data-d'))) { msg.innerHTML = 'That is your current size.'; return; }
      var m2 = null; items.forEach(function (x) { if (x.kind === kind && x.d === d) m2 = x; });
      showResult(line, m2, sizeTxt2, { kind: kind, d: d });
    }
  }

  var lastTarget = null, didSwap = false, checkMode = false;
  function setPanels(open) {
    document.querySelectorAll('[data-ag-change-panel]').forEach(function (p) { p.hidden = !open; });
  }
  function open(target) {
    var ov = overlay(); if (!ov) { window.location = target; return; }
    lastTarget = target;
    ov.classList.add('is-open'); ov.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    loadModelMap().then(function (map) { renderLines(map); });
  }
  function hide() {
    var ov = overlay(); if (ov) { ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); }
    document.documentElement.style.overflow = '';
  }
  // closing by hand after a swap on the cart page: reload so the visible cart matches
  function closeUser() { hide(); if (didSwap && location.pathname.indexOf('/cart') !== -1) window.location.reload(); }
  function proceed() {
    var ds = document.querySelector('[data-ag-gate-dontshow]');
    if (ds && ds.checked) { try { localStorage.setItem('agCartGateDismissed', '1'); } catch (e) {} }
    setConfirmed(); hide(); if (lastTarget) window.location = lastTarget;
  }

  function swap(key, newVid, qty) {
    var card = document.querySelector('.agcg-card'); if (card) card.classList.add('is-busy');
    return postJSON('/cart/add.js', { items: [{ id: Number(newVid), quantity: Number(qty) || 1 }] })
      .then(function () { return postJSON('/cart/change.js', { id: key, quantity: 0 }); })
      .then(function () {
        // re-render in place (no reload) so multi-item carts stay smooth: fix
        // one, fix the next, then one "Yes" confirms the whole cart
        didSwap = true;
        return loadModelMap().then(function (map) { return renderLines(map); });
      })
      .catch(function () {})
      .then(function () { if (card) card.classList.remove('is-busy'); });
  }

  function similar(key, kind, dims) {
    var card = document.querySelector('.agcg-card'); if (card) card.classList.add('is-busy');
    postJSON('/cart/change.js', { id: key, quantity: 0 }).catch(function () {}).then(function () {
      var base = (cfg.searchUrl || '/search') + '?q=*&type=product&options[unavailable_products]=show';
      var u;
      if (kind === 'wxh') {
        u = base + '&filter.p.m.custom.width=' + encodeURIComponent(fmt(dims.w) + '"') + '&filter.p.m.custom.height=' + encodeURIComponent(fmt(dims.h) + '"');
      } else if (kind === 'neck') {
        u = base + '&filter.p.m.custom.neck_size=' + encodeURIComponent(fmt(dims.d) + '"');
      } else {
        u = (cfg.searchUrl || '/search') + '?q=' + encodeURIComponent(fmt(dims.d) + '"') + '&type=product';
      }
      window.location = u;
    });
  }

  // capture-phase checkout interception
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest && e.target.closest(SELECTOR);
      if (!btn) return;
      if (confirmed() || dismissed()) return;
      var target = checkoutTarget(btn);
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(target);
    } catch (err) {}
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-ag-gate-confirm]')) { e.preventDefault(); proceed(); return; }
    if (t.closest('[data-ag-gate-review]')) {
      // reveal (or hide) the size pickers inline so this button actually does
      // something, instead of just closing the modal
      e.preventDefault(); checkMode = !checkMode; setPanels(checkMode);
      return;
    }
    if (t.closest('[data-ag-gate-close]')) { e.preventDefault(); closeUser(); return; }

    var sim = t.closest('[data-ag-similar]');
    if (sim) {
      e.preventDefault(); var l = sim.closest('[data-ag-line]'); var kind = sim.getAttribute('data-kind') || 'wxh';
      var dims = kind === 'wxh' ? { w: parseFloat(sim.getAttribute('data-w')), h: parseFloat(sim.getAttribute('data-h')) } : { d: parseFloat(sim.getAttribute('data-d')) };
      similar(l.getAttribute('data-key'), kind, dims); return;
    }

    var sw = t.closest('[data-ag-switch]');
    if (sw && !sw.disabled) { e.preventDefault(); var l2 = sw.closest('[data-ag-line]'); var tgt = sw.getAttribute('data-target'); if (tgt) swap(l2.getAttribute('data-key'), tgt, l2.getAttribute('data-qty')); return; }

    if (t.hasAttribute && t.hasAttribute('data-ag-cart-gate')) { closeUser(); }
  });

  document.addEventListener('change', function (e) {
    // checking "don't show again" = confirm + dismiss forever + proceed to checkout
    if (e.target && e.target.matches && e.target.matches('[data-ag-gate-dontshow]')) {
      if (e.target.checked) {
        // commit the opt-out now, then wait ~1s so the shopper sees the tick
        // before the modal closes and checkout proceeds
        try { localStorage.setItem('agCartGateDismissed', '1'); } catch (err) {}
        setTimeout(proceed, 1000);
      }
      return;
    }
    var sel = e.target.closest && e.target.closest('[data-ag-w], [data-ag-h], [data-ag-d]');
    if (!sel) return;
    var line = sel.closest('[data-ag-line]'); if (line) evaluate(line);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var ov = overlay(); if (ov && ov.classList.contains('is-open')) closeUser(); }
  });
})();
